import { createBeefCoPage, createLibrary, withBeefCoProject } from '@beefco/sdk';
import {
  AutoMetricElement,
  AutoMetricGoal,
  AutoMetricParam,
  AutoMetricParams,
  withAutoMetric,
} from '@beef/auto-metric';
import { compose, withReduxStore } from '@beef/redux';

import {
  CrudeContext,
  CrudeLogic,
  CrudeMapper,
  enhancedConnect,
  extractBeefCoDSL,
  lowCodeMetricApi,
  lowCodePageMetrics,
  withCrudeMappingRoot,
} from 'utils/lowCodeHelpers';
import { withSmartAnchors } from 'utils/lowCodeHelpers/hocs/withSmartAnchores';
import { headerAwareSmoothScroll } from 'utils/lowCodeHelpers/utils/headerAwareSmoothScroll';

import { initializeStore } from './store';
import * as LowCodeComponents from '../../LowCode/components';
import * as SharedComponents from '../SharedComponents/index';
import * as PagesComponents from './components';

const library = createLibrary(
  {
    CrudeContext,
    CrudeMapper,
    CrudeLogic,
    AutoMetricElement: enhancedConnect()(AutoMetricElement),
    AutoMetricGoal: enhancedConnect()(AutoMetricGoal),
    AutoMetricParam: enhancedConnect()(AutoMetricParam),
    AutoMetricParams: enhancedConnect()(AutoMetricParams),
    ...LowCodeComponents,
    ...SharedComponents,
    ...PagesComponents,
  },
  module,
  { useTsPropParser: true },
);

const _NewsDetails = createBeefCoPage({
  library,
  pageSlug: 'NewsDetails',
});

// https://beefco-stage.apps.yd-kt05.vimpelcom.ru/?url=http://localhost:8080/customers/press/news/details/test
export const NewsDetails = compose(
  withBeefCoProject(undefined, extractBeefCoDSL),
  withReduxStore(initializeStore),
  withCrudeMappingRoot({ selectState: (state) => state.data }),
  withAutoMetric.Root(lowCodeMetricApi, () => ({
    ...lowCodePageMetrics(),
    name: 'news_details',
  })),
  withSmartAnchors([{ regex: /^#scrollTo:(.*)$/, action: headerAwareSmoothScroll }]),
)(_NewsDetails);
